<template>
  <div class="personal-details">
    <div class="personal-details__header">
      <h2 class="personal-details__header__text">Personal details</h2>
    </div>
    <form @submit.prevent="confirmEmail" class="personal-details__form">
      <div class>
        <div
          class="personal-details__form__row personal-details__form__row--zero-top-margin personal-details__form__row--two-column"
        >
          <div class="material-textfield" :class="{'material-textfield--dirty':params.firstName}">
            <input
              class="material-textfield__input"
              type="text"
              required
              name="firstName"
              v-model="params.firstName"
              v-focus
              minlength="2"
            />
            <label class="material-textfield__label" data-content="First Name">First Name</label>
          </div>
          <div class="material-textfield" :class="{'material-textfield--dirty':params.lastName}">
            <input
              class="material-textfield__input"
              type="text"
              required
              name="lastname"
              v-model="params.lastName"
              minlength="2"
            />
            <label class="material-textfield__label" data-content="Last Name">Last Name</label>
          </div>
        </div>
        <div
          class="personal-details__form__row personal-details__form__row--two-column personal-details__form__row--two-column--small"
        >
          <RadioButton
            :className="'radio-button--gender__male'"
            name="gender"
            value="Male"
            @on-change="bindField($event,'gender')"
          />
          <RadioButton
            :className="'radio-button--gender__female'"
            name="gender"
            value="Female"
            @on-change="bindField($event,'gender')"
          />
          <Message v-show="!message.showModal&&message.fieldName==='gender'" :message="message" />
        </div>
        <div class="material-textfield" :class="{'material-textfield--dirty':dob}">
          <input
            class="material-textfield__input"
            type="tel"
            name="dob"
            required
            pattern="^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$"
            minlength="10"
            maxlength="10"
            v-model="dob"
            @keypress="validateDate"
          />
          <label
            class="material-textfield__label"
            data-content="Date of Birth (DD/MM/YYYY)"
          >Date of Birth (DD/MM/YYYY)</label>
          <Message v-show="!message.showModal&&message.fieldName==='dob'" :message="message" />
        </div>
        <div class="material-textfield" :class="{'material-textfield--dirty':params.email}">
          <input
            class="material-textfield__input"
            type="email"
            name="email"
            required
            v-model="params.email"
            :disabled="presetEmail&&presetEmail.length>2"
          />
          <label class="material-textfield__label" data-content="Email">Email</label>
        </div>
        <Message v-show="!message.showModal&&message.fieldName==='email'" :message="message" />
        <div class="personal-details__form__row">
          <label class="personal-details__form__row__label">Select an educational qualification</label>
          <select
            name="education_dropdown"
            class="personal-details__form__row__dropdown"
            required
            v-model="params.education"
          >
            <option value disabled selected>Educational Qualification</option>
            <option value="Below Matric">Below Matric</option>
            <option value="10th">10th Pass</option>
            <option value="12th">12th Pass</option>
            <option value="Graduate">Graduate</option>
            <option value="PG">Post Graduate</option>
            <option value="Professional">PHD</option>
          </select>
          <Message v-show="!message.showModal&&message.fieldName==='education'" :message="message" />
        </div>
        <div class="material-textfield" :class="{'material-textfield--dirty':params.pan}">
          <input
            class="material-textfield__input material-textfield__input--pan"
            type="text"
            required
            name="pan"
            pattern="[A-Za-z]{5}\d{4}[A-Za-z]{1}"
            minlength="10"
            maxlength="10"
            v-model="params.pan"
          />
          <label class="material-textfield__label" data-content="PAN">PAN</label>
        </div>
        <Message v-show="!message.showModal&&message.fieldName==='pan'" :message="message" />
        <div class="material-textfield" :class="{'material-textfield--dirty':params.address.line1}">
          <input
            class="material-textfield__input"
            type="text"
            required
            name="line1"
            v-model="params.address.line1"
            minlength="5"
          />
          <label
            class="material-textfield__label"
            data-content="Current Residential Address"
          >Current Residential Address</label>
        </div>
        <Message v-show="!message.showModal&&message.fieldName==='line1'" :message="message" />
        <div
          class="material-textfield"
          :class="{'material-textfield--dirty':params.address.postcode}"
        >
          <input
            class="material-textfield__input"
            type="tel"
            required
            name="postcode"
            pattern="[0-9]{6}"
            minlength="6"
            maxlength="6"
            v-model="params.address.postcode"
            v-numericOnly
          />
          <label class="material-textfield__label" data-content="Pincode">Pincode</label>
        </div>
        <Message v-show="!message.showModal&&message.fieldName==='postcode'" :message="message" />
        <div class="personal-details__form__row personal-details__form__row--salary">
          <label
            class="personal-details__form__row__label personal-details__form__row__label--salary"
            for="salary"
          >Are you salaried?</label>
          <input
            class="personal-details__form__row__toggle"
            name="salary"
            id="salary"
            type="checkbox"
            v-model="params.salaried"
          />
          <Message v-show="!message.showModal&&message.fieldName==='salaried'" :message="message" />
        </div>
        <template v-if="message && message.showModal">
          <Overlay @on-click="unsetErrors" />
          <ConfirmationModal :message="message">
            <template v-slot:close-button>
              <button class="close-button" type="button" @click="unsetErrors">
                <img src="../../static/images/cross.svg" alt="Close Button" />
              </button>
            </template>
            <ActionButton
              v-slot:default
              v-for="(action,index) in message.actions"
              :key="index"
              @click="action.method"
              :title="action.title"
              :className="action.isPrimary?'':'action-button--alternate'"
              type="button"
            />
          </ConfirmationModal>
        </template>
      </div>
      <ActionButton title="Continue" />
    </form>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ActionButton from "../components/ActionButton";
import RadioButton from "../components/SignupRadioButton";
import Message from "../components/SignupInfoMessage";
import Overlay from "../components/Overlay";
import ConfirmationModal from "../components/ConfirmationModal";
export default {
  name: "Sign-Up-Personal-Details",
  data() {
    return {
      params: {
        firstName: undefined,
        lastName: undefined,
        gender: undefined,
        dob: undefined,
        email: undefined,
        pan: undefined,
        address: {
          line1: undefined,
          postcode: undefined
        },
        salaried: true,
        education: ""
      },
      incorrectDateFormat: false,
      message: {
        value: undefined,
        type: undefined,
        className: undefined,
        fieldName: undefined,
        actions: undefined,
        showModal: undefined
      },
      dob: undefined
    };
  },
  components: {
    ActionButton,
    RadioButton,
    Message,
    Overlay,
    ConfirmationModal
  },
  computed: {
    ...mapGetters(["loggedIn", "presetEmail", "signupStatus"])
  },
  watch: {
    dob(newDate, oldDate) {
      if (newDate.length === 10) {
        this.incorrectDateFormat = this.validateDateValue(newDate);
        if (this.incorrectDateFormat) {
          this.message = {
            value: "Please enter date in correct format",
            type: "error",
            className: "message--error",
            fieldName: "dob"
          };
        } else {
          this.message = {
            value: undefined,
            type: undefined,
            className: undefined,
            fieldName: undefined
          };
        }
      }
    }
  },
  mounted() {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SCREEN",
      propertyName: "SCREEN_NAME",
      propertyValue: "PERSONAL_DETAILS"
    });
    if (this.presetEmail) {
      this.params.email = this.presetEmail;
    }
  },
  created() {
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", () => {
      history.pushState(null, null, document.URL);
      this.message = {
        type: "error",
        fieldName: "email",
        value: `Are you sure you want to skip the ePayLater registration?`,
        showModal: true,
        actions: [
          {
            title: "Yes",
            method: () => this.$router.push({ name: "Login" }),
            isPrimary: false
          },
          {
            title: "No",
            method: () => this.unsetErrors(),
            isPrimary: true
          }
        ]
      };
    });
  },
  updated() {},
  methods: {
    confirmEmail() {
      if (this.signupStatus.userSignupStatus === "V1_REGISTERED") {
        this.submitPersonalDetails();
      } else {
        this.message = {
          type: "error",
          fieldName: "email",
          value: `Please ensure that your email id is entered correctly as it cannot be changed later.<br/> <br/>${this.params.email}`,
          showModal: true,
          actions: [
            {
              title: "Confirm",
              method: () => this.submitPersonalDetails(),
              isPrimary: true
            },
            {
              title: "I want to edit",
              method: () => this.unsetErrors(),
              isPrimary: false
            }
          ]
        };
      }
    },
    submitPersonalDetails() {
      this.$store
        .dispatch("generateRecaptcha", { action: "mobile" })
        .then(token => {
          this.params.recaptcha = token;

          this.$store
            .dispatch("personal_details", this.params)
            .then(response => {
              this.$store.commit("SET_DMI_ELIGIBLE", response.dmiEligible);
              this.$store.dispatch("storeMixpanelEvent", {
                eventName: "PERSONAL_DETAILS_ENTERED",
                propertyName: "DMI_ELIGIBLE",
                propertyValue: response.dmiEligible ? "YES" : "NO"
              });
              this.$scrollToTop();
              this.$store
                .dispatch("resolveSignupRoute", response.signupStatus)
                .then(response =>
                  this.$router.push({ name: response.routeName })
                )
                .catch(() => this.$router.push({ name: "Signup" }));
            })
            .catch(err => {
              if (err.status === 401) {
                this.$router.push({ name: "Signup" });
              } else {
                this.message = {
                  type: "warning",
                  className: "message--error",
                  fieldName: "generic",
                  value: err.data.message,
                  showModal: true,
                  actions: [
                    {
                      title: "Ok",
                      method: () => this.unsetErrors(),
                      isPrimary: true
                    }
                  ]
                };
              }
            });
        });
    },
    bindField(event, value1, value2 = "") {
      value2
        ? (this.params[value1][value2] = event.target.value)
        : (this.params[value1] = event.target.value);
    },
    findFieldName(message) {
      return ["pan", "pincode", "email"].find(fieldname =>
        message.indexOf(fieldname) > -1 ? fieldname : undefined
      );
    },
    validateDate(e) {
      if (e.keyCode < 47 || e.keyCode > 57) {
        e.preventDefault();
      }
      if (this.dob) {
        let len = this.dob.length;
        if (len !== 1 || len !== 3) {
          if (e.keyCode == 47) {
            e.preventDefault();
          }
        }
        if (len === 2) {
          this.dob += "/";
        }
        if (len === 5) {
          this.dob += "/";
        }
      }
    },
    validateDateValue(number) {
      let numbers = number.split("/");
      this.params.dob = `${numbers[2]}-${numbers[1]}-${numbers[0]}`;
      const newDate = new Date(`${numbers[2]}-${numbers[1]}-${numbers[0]}`);
      if (newDate.getTime()) {
        return false;
      } else {
        return true;
      }
    },
    unsetErrors() {
      this.message = {};
    }
  }
};
</script>
<style lang="scss" scoped>
.personal-details {
  max-width: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  &__header {
    margin: 0 -2rem;
    padding: 0.5rem 2rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1;
    @media only screen and (min-width: 640px) {
      display: grid;
      position: relative;
      grid-template-columns: minmax(auto, 30rem);
      background: var(--white);
      text-align: center;
      padding: 2rem 0;
      justify-content: center;
      box-shadow: unset;
      margin: unset;
    }
    &__text {
      font-size: 2.2rem;
      font-weight: 500;
      color: var(--gray-2);
      position: relative;
      margin-top: 10px;
      @media only screen and (min-width: 640px) {
        &::before {
          content: "";
          position: absolute;
          left: 50%;
          bottom: -1rem;
          height: 0.1rem;
          width: 20%;
          border-bottom: 0.1rem solid var(--gray-4);
          transform: translateX(-50%);
        }
      }
    }
  }
  &__form {
    display: grid;
    grid-template-rows: 1fr auto;
    &__row {
      display: grid;
      grid-template-columns: 1fr;
      justify-content: start;
      margin: 3rem 0;
      align-items: center;
      position: relative;
      &--salary {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      &--gap-4 {
        grid-gap: 1rem;
      }

      &--two-column {
        gap: 1rem;
        grid-template-columns: repeat(2, 1fr);
        &--small {
          grid-template-columns: repeat(2, auto);
          gap: 1rem;
        }
        @media only screen and (min-width: 640px) {
          gap: 3rem;
        }
      }

      &--triple-column {
        grid-template-columns: repeat(3, auto);
        gap: 1rem;
      }
      &--zero-top-margin {
        margin-top: 0;
      }
      &__label {
        margin-bottom: 0;
        font-size: 1.4rem;
        color: var(--gray-7);
        font-weight: normal;
        &--salary {
          font-size: 1.4rem;
          color: var(--gray-9);
        }
      }
      &__toggle {
        appearance: none;
        width: 3rem;
        height: 1.5rem;
        display: inline-block;
        position: relative;
        border-radius: 3rem;
        overflow: hidden;
        outline: none;
        border: none;
        cursor: pointer;
        background-color: var(--gray-11);
        transition: background-color ease 0.3s;
        &::before {
          content: "";
          display: block;
          position: absolute;
          z-index: 2;
          width: 1rem;
          height: 1rem;
          background: var(--white);
          left: 0.2rem;
          top: 0.2rem;
          border-radius: 50%;
          text-shadow: -1px -1px rgba(0, 0, 0, 0.15);
          white-space: nowrap;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
          transition: all cubic-bezier(0.3, 1.5, 0.7, 1) 0.3s;
        }
        &:checked {
          background-color: var(--primary-color);
          &::before {
            left: 1.6rem;
          }
        }
      }
      &__dropdown {
        width: 100%;
        padding-right: 5.5rem;
        font-size: 1.6rem;
        border: none;
        font-size: 1.8rem;
        border-bottom: solid 0.06rem var(--gray-4);
        appearance: none;
        background: url("../../static/images/chevron-down.svg") 100%/3%
          no-repeat;
        color: var(--gray-2);
        outline: none;
        &:required:invalid {
          color: var(--gray-3);
        }
        &:valid {
          border-bottom: solid 0.06rem var(--primary-color);
          & ~ label {
            color: var(--primary-color);
          }
        }
        &:invalid {
          border-bottom: solid 0.06rem var(--error);
        }
      }
    }
  }
}
.close-button {
  background: transparent;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SignupPersonalDetails.vue